module.exports = __webpack_public_path__ + "static/img/合照6.4adb2b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照6.jpg
// module id = RMLL
// module chunks = 1